import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard, Grid } from 'swiper/modules';
import { getOffset } from '../../utilities/js/helper.js';

class DownloadsSlider {
    constructor (element) {
        this.$downloads = element;
        this.$slider = this.$downloads.querySelectorAll('[data-downloads="slider"]');
        this.$sliderWrapper = this.$downloads.querySelector('[data-downloads="wrapper"]');
        this.$sliderClusterContainer = document.querySelectorAll('[data-downloads="cluster"]')[0];
        this.$sliderItem = this.$downloads.querySelectorAll('[data-download="stack"]');
        this.$sliderShow = this.$downloads.querySelectorAll('[data-downloads="show"]');
        this.$sliderHide = this.$downloads.querySelectorAll('[data-downloads="hide"]');
        this.$sliderFractionContainer = this.$downloads.querySelector('[data-downloads="fraction-container"]');
        this.$stackContainer = this.$downloads.querySelector('[data-downloads-items]');
        this.$stackItemLength = parseInt(this.$stackContainer.getAttribute('data-downloads-items'));
        this.$tabTitle = document.querySelectorAll('[data-tab-title]');
        this.slider = undefined;
        this.$header = document.querySelector('[data-navigation="root"]');
    }

    // set events on init
    initialize () {
        if (this.$stackItemLength > 0) {
            this.setEvents();

            window.addEventListener('resize', () => {
                this.setEvents();
            });

            for (let i = 0; i < this.$sliderShow.length; i++) {
                this.showHideActions(this.$sliderShow[i]);
            }
        }
    }

    showHideActions ($actions) {
        const stackItemLength = parseInt(this.$stackContainer.getAttribute('data-downloads-items'));

        if (window.innerWidth < 420) {
            if (stackItemLength > 1) {
                $actions.classList.add('is--visible');
                $actions.classList.remove('is--hidden');
            }
        }

        if (window.innerWidth < 767) {
            if (stackItemLength > 2) {
                $actions.classList.add('is--visible');
                $actions.classList.remove('is--hidden');
            }
        }

        if (window.innerWidth >= 767 && window.innerWidth < 1024) {
            if (stackItemLength > 3) {
                $actions.classList.add('is--visible');
                $actions.classList.remove('is--hidden');
            }
        }

        if (window.innerWidth > 1024) {
            if (stackItemLength > 4) {
                $actions.classList.add('is--visible');
                $actions.classList.remove('is--hidden');
            }

            if (stackItemLength <= 4) {
                $actions.classList.remove('is--visible');
                $actions.classList.add('is--hidden');
            }
        }
    }

    // set slider button functions
    setEvents () {
        this.addSliderSettings();
        this.removeSliderSettings();
        this.handleTabTitle();
    }

    // set settings on init slider
    addSliderSettings () {
        for (let i = 0; i < this.$sliderShow.length; i++) {
            this.$sliderShow[i].addEventListener('click', () => {
                if (this.$stackItemLength >= 8) {
                    if (this.$sliderFractionContainer) {
                        this.$sliderFractionContainer.classList.remove('is--hidden');
                        this.$sliderFractionContainer.classList.add('is--visible');
                    }

                    this.$sliderWrapper.classList.add('is-active');
                    this.initSlider();
                } else {
                    this.$sliderWrapper.classList.add('is--null');
                }

                this.$sliderClusterContainer.classList.add('slider--active');

                this.$sliderShow[i].classList.remove('is--visible');
                this.$sliderShow[i].classList.add('is--hidden');

                for (let i = 0; i < this.$sliderHide.length; i++) {
                    this.$sliderHide[i].classList.remove('is--hidden');
                    this.$sliderHide[i].classList.add('is--visible');
                }

                for (let i = 0; i < this.$sliderItem.length; i++) {
                    this.$sliderItem[i].classList.add('is--visible');
                }
            });
        }
    }

    // remove settings and destroy slider
    removeSliderSettings () {
        for (let i = 0; i < this.$sliderHide.length; i++) {
            this.$sliderHide[i].addEventListener('click', () => {
                this.$sliderHide[i].classList.remove('is--visible');
                this.$sliderHide[i].classList.add('is--hidden');
                this.$sliderWrapper.classList.add('is-active');

                for (let i = 0; i < this.$sliderShow.length; i++) {
                    this.$sliderShow[i].classList.remove('is--hidden');
                    this.$sliderShow[i].classList.add('is--visible');
                }

                for (let i = 0; i < this.$sliderItem.length; i++) {
                    this.$sliderItem[i].classList.remove('is--visible');
                }

                this.$sliderClusterContainer.classList.remove('slider--active');
                if (this.$sliderFractionContainer) {
                    this.$sliderFractionContainer.classList.remove('is--visible');
                    this.$sliderFractionContainer.classList.add('is--hidden');
                }
                this.$sliderWrapper.classList.remove('is--null');
                this.destroySlider();

                const $downloadsRoot = this.$downloads.closest('.download__group');
                let downloadsTop = getOffset($downloadsRoot).top - 10;

                if (this.$header) {
                    const headerHeight = parseInt(this.$header.offsetHeight);
                    downloadsTop = downloadsTop - headerHeight;
                }

                window.scrollTo({
                    top: downloadsTop,
                    left: 0,
                    behavior: 'smooth'
                });
            });
        }
    }

    // init slider function
    initSlider () {
        this.slider = new Swiper(this.$downloads, {
            modules: [A11y, Navigation, Pagination, Keyboard, Grid],
            a11y: true,
            keyboard: true,
            allowTouchMove: true,
            slidesPerView: 'auto',
            grid: {
                rows: 2,
                fill: 'row'
            },
            pagination: {
                el: this.$downloads.querySelector('[data-downloads="fraction"]'),
                type: 'fraction'
            },
            navigation: {
                prevEl: this.$downloads.querySelector('[data-downloads="prev"]'),
                nextEl: this.$downloads.querySelector('[data-downloads="next"]')
            },
        });
    }

    handleTabTitle () {
        for (let i = 0; i < this.$tabTitle.length; i++) {
            this.$tabTitle[i].addEventListener('click', () => {
                this.$tabTitle[i].classList.remove('is-active');
                this.$sliderWrapper.classList.add('is-active');

                for (let i = 0; i < this.$sliderHide.length; i++) {
                    this.$sliderHide[i].classList.add('is--hidden');
                    this.$sliderHide[i].classList.remove('is--visible');
                }

                for (let i = 0; i < this.$sliderShow.length; i++) {
                    this.showHideActions(this.$sliderShow[i]);
                }

                for (let i = 0; i < this.$sliderItem.length; i++) {
                    this.$sliderItem[i].classList.remove('is--visible');
                }

                this.$sliderClusterContainer.classList.remove('slider--active');
                if (this.$sliderFractionContainer) {
                    this.$sliderFractionContainer.classList.remove('is--visible');
                    this.$sliderFractionContainer.classList.add('is--hidden');
                }
                this.$sliderWrapper.classList.remove('is--null');
                this.destroySlider();
            });
        }
    }

    // destroys slider
    destroySlider () {
        if (this.slider) {
            this.slider.destroy(true, true);
        }
    }
}

export { DownloadsSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-downloads="slider"]');
        $$roots.forEach($root => {
            const $rootAPI = new DownloadsSlider($root);
            $rootAPI.initialize();
        });
    }
});
